import Route from '@core/components/Route';
import Box from '@mui/material/Box';
import { FC, memo } from 'react';

import { CardContentProps } from '../types/card-content-props';
import ConditionalText from './CardConditionalText';
import Paragraph from './Paragraph';
import Video from './Video';

const CardMobileContent: FC<CardContentProps> = ({
  card: { shop, texts, texts1, texts2, texts3, video },
}) => (
  <>
    {texts && <ConditionalText texts={texts} />}
    {texts1 && <ConditionalText texts={texts1} />}

    {shop && (
      <Box sx={{ marginTop: '1.5rem', textAlign: 'center' }}>
        {shop.video && <Video horizontal={shop.video.horizontal} src={shop.video.src} />}
        <Paragraph margin='0'>
          Mehr dazu in unserem <Route href={shop.href}>Online Shop</Route>.
        </Paragraph>

        {texts2 && <ConditionalText texts={texts2} withBox />}

        {video && (
          <Box sx={{ marginTop: '1.5rem' }}>
            <Video horizontal={video.horizontal} src={video.src} />
            {texts3 && <ConditionalText texts={texts3} withBox />}
          </Box>
        )}
      </Box>
    )}

    {!shop && video && (
      <Box sx={{ marginTop: '1.5rem' }}>
        <Video horizontal={video.horizontal} src={video.src} />
        {texts2 && <ConditionalText texts={texts2} withBox />}
      </Box>
    )}
  </>
);

export default memo(CardMobileContent);
